module.exports = __webpack_public_path__ + "img/linkedin.2bd08c63.svg";